import React from 'react'
import LiftStorysLogo from '../atoms/LiftStorysLogo'

const MagazinThemeHero = ({ theme, onResetTheme }) => (
  <section>
    <div className="relative bg-black -top-px -z-1">
      <div className="container flex justify-end">
        <LiftStorysLogo className="h-[84px] w-auto md:h-[118px] xl:h-[160px] relative top-0.5 z-0 md:mb-0" />
      </div>
    </div>
    <div className="container">
      <h1 className="relative inline-block mt-16 u-h0 md:mt-28">
        {theme}
        <button
          type="button"
          className="absolute top-2 -right-8"
          onClick={onResetTheme}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="none"
            viewBox="0 0 22 22"
          >
            <path
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 5l6 6-6 6M17 5l-6 6 6 6"
            ></path>
          </svg>
        </button>
      </h1>
    </div>
  </section>
)

export default MagazinThemeHero
